export default __webpack_public_path__ + "static/spot-illo-morph-dark-e15c65960d615f17151370d7df67bc14c82385043d5051ea126c9a6ce5950801.mp4";